import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import DreamsSection from "./components/DreamsSection";
import ServicesSection from "./components/ServicesSection";
import ProcessSection from "./components/ProcessSection";
import TestimonialsSection from "./components/TestimonialsSection";
import WhyChooseUsSection from "./components/WhyChooseUsSection";
import CreditLinesSection from "./components/CreditLinesSection";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="relative">
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          name: "Authentic Credit Restoration",
          description: "Personal and corporate credit repair services in all 50 states using the Fair Credit Reporting Act of 1984. Speak to an expert — not a robot. Call (754) 777-6321.",
          url: "https://fastestcreditrestoration.com",
          telephone: "+17547776321",
          email: "info@fastestcreditrestoration.com",
          areaServed: "United States",
          priceRange: "$$",
        })}
      </script>

      <Navbar />
      <main>
        <HeroSection />
        <DreamsSection />
        <ServicesSection />
        <ProcessSection />
        <WhyChooseUsSection />
        <TestimonialsSection />
        <CreditLinesSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}